var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "1.1143125 1.015425 8.38125 1.015425 8.38125 13.453425 1.1143125 13.453425"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_product",
    transform: "translate(2.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.44885,18 C7.32735,17.9505 7.242975,17.929125 7.173225,17.886375 C4.84785,16.473375 2.524725,15.058125 0.198225,13.647375 C0.05535,13.56075 -0.0009,13.469625 0.000208483342,13.298625 C0.0081,10.56825 0.0081,7.839 0.009225,5.10975 C0.009225,5.031 0.009225,4.953375 0.009225,4.833 C0.33885,5.025375 0.6336,5.194125 0.924975,5.369625 C3.035475,6.642 5.145975,7.91775 7.25985,9.185625 C7.407225,9.2745 7.45335,9.370125 7.452245,9.53775 C7.447725,12.267 7.44885,14.997375 7.44885,17.726625 L7.44885,18 Z",
    id: "Fill-1",
    fill: "#A3B3C5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(7.875000, 4.500000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3683125,1.015425 C8.3683125,1.400175 8.3683125,1.74105 8.3683125,2.081925 C8.3716875,4.57605 8.3728125,7.0713 8.3818125,9.565425 C8.3818125,9.71505 8.2996875,9.761175 8.1984375,9.81405 C6.2195625,10.8423 4.2418125,11.871675 2.2629375,12.8988 C1.9535625,13.05855 1.6385625,13.210425 1.3258125,13.365675 C1.2684375,13.3938 1.2076875,13.4163 1.1188125,13.453425 L1.1188125,13.20705 C1.1188125,10.45755 1.1199375,7.706925 1.1143125,4.957425 C1.1143125,4.793175 1.1660625,4.709925 1.3111875,4.635675 C3.5825625,3.472425 5.8505625,2.302425 8.1196875,1.134675 C8.1826875,1.10205 8.2490625,1.0728 8.3683125,1.015425",
    id: "Fill-3",
    fill: "#A3B3C5",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.9604125,3.57525 C1.0312875,3.5325 1.0796625,3.499875 1.1302875,3.472875 C3.3386625,2.334375 5.5470375,1.195875 7.7531625,0.054 C7.8915375,-0.016875 7.9972875,-0.021375 8.1390375,0.061875 C10.5251625,1.477125 12.9157875,2.8845 15.3041625,4.294125 C15.3322875,4.311 15.3570375,4.332375 15.4065375,4.368375 C15.0791625,4.545 14.7709125,4.719375 14.4559125,4.881375 C12.4162875,5.936625 10.3755375,6.989625 8.3370375,8.047125 C8.2200375,8.107875 8.1424125,8.078625 8.0445375,8.017875 C6.1612875,6.8355 4.2757875,5.657625 2.3914125,4.4775 C1.9200375,4.18275 1.4509125,3.884625 0.9604125,3.57525",
    id: "Fill-6",
    fill: "#A3B3C5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProduct);
export default __webpack_public_path__ + "static/media/icon_product.6c264750.svg";
export { ForwardRef as ReactComponent };